

(function(window, jQuery) {
  var $window = jQuery(window);

  /**
   * Basic helper object that auto-focuses on the search input field when the
   * toggle is clicked. Is expected to be place "on to of" a bootstrap
   * data-toggle element.
   * We expect a form inside the toggle target, and we auto-focus on the first
   * field in the form.
   */
  var SearchToggle = function(element) {
    this.element = element;
    this.input = undefined;

    this.target = jQuery(this.element.data('target'));
    if (this.target.length) {
      var form = this.target.find('form');
      if (form.length) {
        this.input = form.find('input').first();
      } else {
        console.warn('SearchToggle: failed to find a form inside the toggle target');
      }
    } else {
      console.warn('SearchToggle: failed to find toggle target');
    }

    this.toggleShown = this.toggleShown.bind(this);
    this.toggleHidden = this.toggleHidden.bind(this);
  };
  SearchToggle.prototype.modifierClass = 'cs-search-toggle--open';
  SearchToggle.prototype.initialise = function() {
    if (this.target && this.target.length) {
      this.target.on('hidden.bs.collapse', this.toggleHidden);
      this.target.on('shown.bs.collapse', this.toggleShown);
    }
  };
  SearchToggle.prototype.toggleShown = function() {
    this.element.addClass(this.modifierClass);

    if (this.input && this.input.length) {
      this.input.focus();
    }
  };
  SearchToggle.prototype.toggleHidden = function() {
    this.element.removeClass(this.modifierClass);
  };


  $window.on('load', function() {
    var searchToggles = jQuery('[data-sbm-search-toggle]');

    if (searchToggles.length) {
      for (var i = 0; i < searchToggles.length; i++) {
        var item = jQuery(searchToggles[i]);

        var block = new SearchToggle(item);
        block.initialise();
      }
    }
  });
})(window, jQuery);

